module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authenticated) ? _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top navbar-inverse"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": require("../assets/images/lewis-rice-logo-white.svg")
    }
  })])], 1), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-mobile-collapse-menu"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/logout",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v("Logout")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-settings",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v("My Settings")])], 1)])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-mobile-collapse-menu",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-917e6e6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 285
// module chunks = 1